module.exports = __webpack_public_path__ + "static/media/0040.28cea5e7.svg";